<template>
    <router-view @change-locale="change_locale" />
</template>

<script>
export default {
    methods: {
        change_locale() {
            this.$i18n.locale = (this.$i18n.locale === 'ja') ? 'en': 'ja';
            this.$store.commit('save_lang', this.$i18n.locale);
        }
    }
}
</script>